import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { ImagesListName } from '@/common/utils/ImagesListName';
import { getDamagedAdjusterAttachedDocumentImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedDocumentImages/getDamagedAdjusterAttachedDocumentImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const ShowDamagedDocumentImagesTab = () => {
  const { id, damagedId } = useParams();

  const { data: imagesData } = useQuery(
    getDamagedAdjusterAttachedDocumentImagesQueryOptions({
      id: Number(id),
      damaged_id: Number(damagedId),
    }),
  );
  if (!imagesData?.length) {
    return (
      <Box mt="100px">
        <EmptyImagesListIcon className={css({ mx: 'auto' })} />
      </Box>
    );
  }
  return (
    <>
      <Typography textStyle="b1" color="purple-1" my="24px">
        تصاویر مدارک
      </Typography>
      <Flex
        gap="1rem"
        maxWidth="maxContainer"
        margin="auto"
        mt="1.5rem"
        className={grid({ columns: 2 })}
        flexWrap="wrap"
      >
        {imagesData?.map((vehicleImages, index) => {
          return (
            <ImageCard
              key={vehicleImages.id}
              imageData={{
                name: ImagesListName({
                  titleType: 'document',
                  index,
                }),
                src: vehicleImages.image,
              }}
            />
          );
        })}
      </Flex>
    </>
  );
};

export default ShowDamagedDocumentImagesTab;
